import React from "react";
import HeroImg from "../../../assets/AboutHero.png"
import { useNavigate } from "react-router-dom";

export const Hero = () => {
    const navigate = useNavigate()
    return (
        <section className="w-full  py-16 bg-primary-50">
            <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

                {/* LEFT CONTENT */}
                <div className="space-y-6 text-center lg:text-left">
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
                        Empowering Careers Through <br />
                        Practical Innovation
                    </h1>

                    <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                        We are building a learning ecosystem where industry meets
                        education. At SAN LMS, we transform ambition into expertise
                        through structured training, hands-on experience, and expert
                        mentorship.
                    </p>

                    <p className="text-gray-700 text-sm md:text-base leading-relaxed">
                        From foundational knowledge to advanced technical mastery, our
                        programs are designed to prepare learners for real-world
                        challenges and long-term professional growth.
                    </p>

                    <button onClick={()=>navigate('/courses')} className="bg-primary-600 hover:bg-primary-700 text-white px-10 py-3 rounded-lg transition">
                        Explore Our Programs
                    </button>
                </div>

                {/* RIGHT IMAGE SECTION */}
                <div className="relative flex justify-center lg:justify-end">

                    {/* Main Image */}
                    <img
                        src={HeroImg}
                        alt="team"
                        className="shadow-lg object-cover w-full  h-full"
                    />
                </div>

            </div>
        </section>
    );
};